var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tab-pane fade in active",
      attrs: { id: "tab_performance" }
    },
    [
      _c("div", { staticClass: "tab__header" }, [
        _vm._v("Performance Evaluation")
      ]),
      _vm._v(" "),
      _c("Comparisons"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "kpi__table-container kpi__table-container--bordered" },
        [
          _c(
            "table",
            { staticClass: "kpi-performance-table" },
            [
              _c("TableHead", {
                attrs: {
                  title: "A. FINANCIAL PERFORMANCE",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsFinancialPerformance, function(metric, index) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "financial-" + metric.field + "-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              }),
              _vm._v(" "),
              _c("TableHead", {
                attrs: {
                  title: "B. OPERATIONAL PERFORMANCE",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsOperationalPerformance, function(
                metric,
                index
              ) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "operational-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              }),
              _vm._v(" "),
              _c("TableHead", {
                attrs: {
                  title: "C. PERSONNEL PERFORMANCE",
                  "month-year-string": _vm.monthYearString
                }
              }),
              _vm._v(" "),
              _c("TableSubHead"),
              _vm._v(" "),
              _vm._l(_vm.metricsPersonnelPerformance, function(metric, index) {
                return _c(_vm.getComponentName(metric.field), {
                  key: "personnel-" + index,
                  tag: "component",
                  attrs: { metric: metric }
                })
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }